const GA_MEASUREMENT_ID = "G-FHZHJMGBYF";
const INTERACTION_EVENTS = ["pointerdown", "keydown", "touchstart"] as const;
// After load, wait long enough that lab TBT is already closed. Real visits
// that never tap still get a pageview via this fallback.
const FALLBACK_AFTER_LOAD_MS = 15_000;

type Gtag = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: Gtag;
  }
}

function installGtagStub() {
  window.dataLayer = window.dataLayer ?? [];
  window.gtag =
    window.gtag ??
    function gtag() {
      window.dataLayer!.push(arguments);
    };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID);
}

function injectGtagScript() {
  if (document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`)) {
    return;
  }
  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);
}

export function loadDeferredAnalytics() {
  installGtagStub();

  let started = false;
  let fallbackId = 0;

  const start = () => {
    if (started) return;
    started = true;
    window.clearTimeout(fallbackId);
    for (const type of INTERACTION_EVENTS) {
      window.removeEventListener(type, start);
    }
    injectGtagScript();
  };

  for (const type of INTERACTION_EVENTS) {
    window.addEventListener(type, start, { once: true, passive: true });
  }

  const scheduleFallback = () => {
    fallbackId = window.setTimeout(start, FALLBACK_AFTER_LOAD_MS);
  };

  if (document.readyState === "complete") {
    scheduleFallback();
  } else {
    window.addEventListener("load", scheduleFallback, { once: true });
  }
}

export function trackPageView(path: string) {
  window.gtag?.("event", "page_view", { page_path: path });
}
